export const colors = {
  // Primary Palette: Professional Blue
  brand: {
    light: '#F0F9FF', // sky-50
    main: '#0284C7',  // sky-600
    dark: '#0C4A6E',  // sky-900
  },

  // Base Neutrals: Crisp Black & White
  neutral: {
    50: '#FFFFFF',
    100: '#F8FAFC',
    200: '#F1F5F9',
    300: '#E2E8F0',
    400: '#94A3B8',
    500: '#64748B',
    600: '#475569',
    700: '#334155',
    800: '#1E293B',
    900: '#0F172A',
    1000: '#000000',
  },
  
  // Status Accents
  critical: {
    light: '#FEF2F2',
    main: '#EF4444',
    dark: '#991B1B',
  },
  warning: {
    light: '#FFFBEB',
    main: '#F59E0B',
    dark: '#92400E',
  },
  healthy: {
    light: '#F0FDF4',
    main: '#10B981',
    dark: '#065F46',
  },
  info: {
    light: '#E0F2FE',
    main: '#0EA5E9',
    dark: '#075985',
  },

  background: {
    muted: '#F9FAFB',
    default: '#FFFFFF',
    surface: '#FFFFFF',
  }
};

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px',
};

export const shadows = {
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
};

export const tokens = {
  colors,
  spacing,
  shadows,
};
